export const TypeToMaskMapping = {
  phone: '(000) 000-0000',
  card: '0000 0000 0000 0000',
  cardExpiration: '00/00',
  zip: '00000',
  cvc: '0000',
  cvc3: '000',
  dob: '00/00/0000',
  weight: '00000',
  caqh: '00000000',
  npi: '0000000000',
  licenseExpiration: '00/0000',
};


export type MaskedInputType = keyof typeof TypeToMaskMapping;
